import React from 'react';
import './InfoCard.css';

/**
 * InfoCard - Yeniden kullanılabilir bilgi kartı bileşeni
 * 
 * @param {Object} props
 * @param {string} props.icon - Phosphor icon adı (örn: "package", "tag", "shopping-bag")
 * @param {string} props.title - Kart başlığı
 * @param {React.ReactNode} props.children - Kart içeriği
 * @param {string} props.className - Ek CSS sınıfları
 * @param {string} props.iconColor - İkon rengi (default: main-600)
 */
const InfoCard = ({ 
  icon, 
  title, 
  children, 
  className = '',
  iconColor = 'main-600'
}) => {
  return (
    <div className={`info-card bg-white rounded-20 shadow-sm p-24 h-100 transition-3 hover-shadow-lg ${className}`}>
      {/* Kart Başlığı ve İkon */}
      <div className="info-card-header d-flex align-items-center gap-12 mb-20 pb-16 border-bottom border-gray-100">
        <div className={`info-card-icon w-48 h-48 bg-${iconColor} bg-opacity-10 rounded-12 d-flex align-items-center justify-content-center`}>
          <i className={`ph ph-${icon} text-${iconColor} text-24`}></i>
        </div>
        <h6 className="info-card-title mb-0 fw-semibold text-gray-900">
          {title}
        </h6>
      </div>
      
      {/* Kart İçeriği */}
      <div className="info-card-body">
        {children}
      </div>
    </div>
  );
};

/**
 * InfoCardItem - Bilgi kartı içindeki tek bir bilgi satırı
 * 
 * @param {Object} props
 * @param {string} props.label - Etiket
 * @param {string|React.ReactNode} props.value - Değer
 * @param {string} props.icon - Opsiyonel ikon
 */
export const InfoCardItem = ({ label, value, icon }) => {
  if (!value && value !== 0) return null;
  
  return (
    <div className="info-card-item d-flex justify-content-between align-items-start gap-12 mb-12 pb-12 border-bottom border-gray-50">
      <div className="d-flex align-items-center gap-8">
        {icon && <i className={`ph ph-${icon} text-gray-500 text-16`}></i>}
        <span className="text-sm text-gray-600">{label}:</span>
      </div>
      <span className="text-sm fw-medium text-gray-900 text-end">{value}</span>
    </div>
  );
};

/**
 * InfoCardBadge - Bilgi kartı içindeki badge/etiket
 * 
 * @param {Object} props
 * @param {string} props.text - Badge metni
 * @param {string} props.variant - Badge rengi (success, warning, info, danger, primary)
 * @param {string} props.icon - Opsiyonel ikon
 */
export const InfoCardBadge = ({ text, variant = 'primary', icon }) => {
  const colorMap = {
    success: 'bg-success bg-opacity-10 text-success',
    warning: 'bg-warning bg-opacity-10 text-warning',
    info: 'bg-info bg-opacity-10 text-info',
    danger: 'bg-danger bg-opacity-10 text-danger',
    primary: 'bg-primary bg-opacity-10 text-primary',
    main: 'bg-main-600 bg-opacity-10 text-main-600'
  };
  
  return (
    <div className={`info-card-badge d-inline-flex align-items-center gap-6 px-12 py-6 rounded-8 mb-8 ${colorMap[variant] || colorMap.primary}`}>
      {icon && <i className={`ph ph-${icon} text-14`}></i>}
      <span className="text-xs fw-medium">{text}</span>
    </div>
  );
};

export default InfoCard;

